const t = {
  Active: "ACTIVE",
  Inactive: "INACTIVE"
};
export {
  t as h
};
//# sourceMappingURL=MyShop-2b356663.mjs.map
